import { render, staticRenderFns } from "./BreakoutColumn.vue?vue&type=template&id=6e051484"
import script from "./BreakoutColumn.vue?vue&type=script&lang=js"
export * from "./BreakoutColumn.vue?vue&type=script&lang=js"
import style0 from "./BreakoutColumn.vue?vue&type=style&index=0&id=6e051484&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports